module.exports = __webpack_public_path__ + "static/tour-f9948ea0123166ea3e3001ceb693c335.svg";